import { baseApi } from "../api";

export const debugApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		clearAppPurchaseData: builder.mutation({
			query: () => ({
				url: "/rest/debug/user/clear-app-purchase-data",
				method: "POST"
			})
		})
	})
});

export const { useClearAppPurchaseDataMutation } = debugApi;
